/* eslint-disable react/require-default-props,react/destructuring-assignment */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';
import cn from 'classnames';

import Modal from '../Modal';
import Dialog from '../Dialog';
import LocalizationContextWrapper from '../LocalizationContextWrapper';
import { actions as popupActions } from '../../../redux/ui/popup';
import { popupSecondaryContentVisibilitySelector } from '../../../redux/ui/selectors';
import styles from './index.styl';

const mapStateToProps = state => ({
  secondaryContentVisible: popupSecondaryContentVisibilitySelector(state),
});

const mapDispatchToProps = {
  toggleContent: popupActions.toggleContent,
};

@injectIntl
@connect(
  mapStateToProps,
  mapDispatchToProps,
)
@CSSModules(styles, { allowMultiple: true })
export default class Popup extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    mobileFullScreen: PropTypes.bool,
    extraContentClassName: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    onClose: PropTypes.func,
    opened: PropTypes.bool,
    returnable: PropTypes.bool,
    centered: PropTypes.bool,
    secondaryContentVisible: PropTypes.bool,
    toggleContent: PropTypes.func,
    isLayoutColumn: PropTypes.bool,
    overflowVisible: PropTypes.bool,
    dialogPadding: PropTypes.string,
    disableFillBackground: PropTypes.bool,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }),
  };

  render() {
    if (!this.props.opened) return null;

    const {
      children,
      intl,
      returnable,
      centered,
      secondaryContentVisible,
      overflowVisible,
      disableFillBackground,
      className,
      style,
    } = this.props;

    const onClose =
      returnable && secondaryContentVisible
        ? this.props.toggleContent
        : this.props.onClose;

    return (
      <Modal>
        <div
          style={style}
          className={className}
          styleName={cn('root', {
            'root--overflow-visible': overflowVisible,
            'root--disableFillBackground': disableFillBackground,
            'root--centered': centered,
          })}
        >
          <Dialog {...this.props} {...{ onClose }}>
            <LocalizationContextWrapper intl={intl}>
              {children}
            </LocalizationContextWrapper>
          </Dialog>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Popup/index.jsx